import { createApp } from 'vue';
import Modals from './Modals.vue';
import { getPiniaInstance } from '../../store/page-store';
import TransFilter from '../../../qaamgo/modules/sat/components/mixins/TransFilter.vue'

createApp(Modals).use(getPiniaInstance()).mount('#qg-modal');
